<template>
  <PullRefresh
    v-model="refresh"
    :style="{ height: scrollHeight, overflow: 'auto' }"
    :loading-text="''"
    @refresh="onRefresh"
  >
    <!-- 下拉提示 -->
    <template #pulling>
      <div class="lottie_style">
        <CarLottie />
      </div>
    </template>

    <!-- 释放提示 -->
    <template #loosing>
      <div class="lottie_style">
        <CarLottie />
      </div>
    </template>

    <!-- 加载提示 -->
    <template #loading>
      <div class="lottie_style">
        <CarLottie />
      </div>
    </template>
    <slot />
  </PullRefresh>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { PullRefresh } from 'vant'
import CarLottie from '@core/components/CarLottie.vue'

const props = defineProps({
  scrollHeight: {
    // 下拉区域始终为全屏的高度
    type: String,
    default: '100%'
  },
  refreshing: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['onRefresh', 'update:refreshing'])

const refresh = computed({
  get: () => props.refreshing,
  set: (val) => {
    emits('update:refreshing', val)
  }
})

const onRefresh = () => {
  emits('onRefresh')
}
</script>

<style lang="less" scoped>
.pull_to_refresh {
  height: 100%;
}
.lottie_style {
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.van-pull-refresh__head) {
  height: 60px;
}
</style>
